export default function ServicesHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/c70492df75a9c15a74cfe6fa324e4743.jpg"
          alt="Elite Medical Training Services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-[9px] uppercase tracking-[0.25em] text-[#D4C4B0] font-light mb-6">
          Elite Training Programs
        </div>
        <h1 className="text-[48px] sm:text-[64px] md:text-[80px] lg:text-[96px] font-bold text-white mb-6 leading-[1.1] font-serif">
          Training That<br />Saves Lives
        </h1>
        <p className="text-[16px] sm:text-[18px] md:text-[20px] text-[#C0C0C0] max-w-[800px] mx-auto leading-relaxed mb-12">
          Specialized medical security training programs designed for high-stakes environments where seconds matter and excellence is non-negotiable.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#programs" 
            className="px-8 py-4 bg-[#D4C4B0] text-black text-[14px] font-semibold tracking-wide rounded-lg hover:bg-[#C4B4A0] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Programs
          </a>
          <a 
            href="#contact" 
            className="px-8 py-4 bg-transparent border-2 border-white text-white text-[14px] font-semibold tracking-wide rounded-lg hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Request Consultation
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-[32px] text-white/60"></i>
      </div>
    </section>
  );
}
